(function () {
    "use strict";
    realmCommerceApp.factory("messagesService", messagesService);

    /*@ngInject*/
    function messagesService(toastr, flashBagMessages) {
        var service = {
            messages: (flashBagMessages) ? flashBagMessages : [],
            getMessages: getMessages,
            clearMessages: clearMessages,
            success: success,
            warning: warning,
            info: info,
            danger: danger,
            addMessage: addMessage
        };
        return service;

        function success(message, options) {
            toastr.success(message.text);
        }

        function warning(message, options) {
            toastr.warning(message.text);
        }

        function danger(message, options) {
            toastr.error(message.text);
        }

        function info(message, options) {
            toastr.info(message.text);
        }

        function addMessage(message) {
            service.messages.push(message);
        }

        function getMessages() {
            return service.messages;
        }

        function clearMessages() {
            service.messages = [];
        }
    }
})();


// WEBPACK FOOTER //
// ./static/js/app/services/messages.service.js